export default {
	id: 'SIMPLE_PREMIUM_3M_62_3M_17_99',
	providers: {
		paltaMap: {
			EUR: 'simple_premium_3m_62_3m_17_99_eur',
		},
		primer: 'prd_0iJTvtWfMwpD',
	},
	model: {
		commitment_period: 0,
		intro_period_value: 3,
		intro_period_type: 'month',
		next_period_value: 3,
		next_period_type: 'month',
	},
	trial: {
		days: 90,
		priceMap: {
			EUR: 17.99,
		},
		originalPriceMap: {
			EUR: 62,
		},
	},
	subscription: {
		interval: 'month',
		intervalCount: 3,
		priceMap: {
			EUR: 62,
		},
	},
	options: ($t) => ({
		explicitTermsPeriodText: $t('pages.program.organic.cheap_and_short.plans.90_days.into_period_text'), // 'first quarter'
		explicitTermsIntervalText: $t('pages.program.organic.cheap_and_short.plans.90_days.sub_period_text'), // 'quarterly'
		billingSubtitlePeriodText: $t('pages.program.cheap_and_short.plans.90_days.into_period_text'), // 'three months'
		footerPeriodText: $t('pages.program.cheap_and_short.plans.90_days.period_text'), // '3-month'
		footerIntervalText: $t('pages.program.cheap_and_short.plans.90_days.sub_period_text'), // '3-month'
	}),
}
